import locales from './locales'
import pt from './pt.json'

const messages = { pt }

const defaultKey = Object.keys(locales).find(key => locales[key].default)
const defaultLocale = locales[defaultKey].locale

export { defaultLocale, messages, locales }
